import { useState } from "react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { api, errMsg, lim } from "../lib/api";
import { useLoad, StatusBadge } from "./common";

function LimitRow({ uid, a, reload }) {
  const [f, setF] = useState({ lead_daily: a.lead_daily ?? "", text_daily: a.text_daily ?? "" });
  const num = (v) => (v === "" || v == null ? null : Number(v));
  const save = async () => {
    try { await api.patch(`/admin/users/${uid}/entrance-accounts/${a.account_id}`, { lead_daily: num(f.lead_daily), text_daily: num(f.text_daily) }); toast.success("Limits saved"); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <tr data-testid={`acct-row-${a.account_id}`}>
      <td className="font-medium">{a.name}</td>
      <td><StatusBadge s={a.connected ? "completed" : "pending"} label={a.connected ? "connected" : "not connected"} /></td>
      {a.account_id === "main" ? <td colSpan={2} className="text-xs text-zinc-500">Uses the limits on this page ({lim(a.lead.allowance)} leads · {lim(a.text.allowance)} texts)</td> : <>
        <td><input type="number" min={0} className="fld w-24" value={f.lead_daily} onChange={(e) => setF({ ...f, lead_daily: e.target.value })} data-testid={`acct-lead-${a.account_id}`} /></td>
        <td><input type="number" min={0} className="fld w-24" value={f.text_daily} onChange={(e) => setF({ ...f, text_daily: e.target.value })} data-testid={`acct-text-${a.account_id}`} /></td></>}
      <td className="num text-xs">{a.lead.used}</td>
      <td>{a.account_id !== "main" && <Button size="sm" onClick={save} data-testid={`acct-save-${a.account_id}`}>Save</Button>}</td>
    </tr>
  );
}

export function EntranceAccountsDialog({ user, onClose }) {
  const [d, reload] = useLoad(async () => (await api.get(`/admin/users/${user.id}/entrance-accounts`)).data);
  const toggle = async () => {
    try { await api.post(`/admin/users/${user.id}/multi-entrance`, { enabled: !d.multi_entrance }); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-white max-w-3xl" data-testid="entrance-accounts-dialog">
        <DialogHeader><DialogTitle>Entrance accounts · {user.display_name}</DialogTitle></DialogHeader>
        {d && <>
          <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={d.multi_entrance} onChange={toggle} data-testid="multi-entrance-toggle" />
            Allow more than one Entrance account (they add and name them on My Entrance)</label>
          <div className="overflow-x-auto"><table className="dt"><thead><tr><th>Account</th><th>Status</th><th>Leads/day</th><th>Texts/day</th><th className="num">Used today</th><th /></tr></thead>
            <tbody>{d.accounts.length ? d.accounts.map((a) => <LimitRow key={a.account_id} uid={user.id} a={a} reload={reload} />)
              : <tr><td colSpan={6} className="text-sm text-zinc-500">No Entrance account connected yet.</td></tr>}</tbody></table></div>
          <p className="text-[11px] text-zinc-500">Each extra account has its own daily lead and text limit; they add to the team's total.</p>
        </>}
      </DialogContent>
    </Dialog>
  );
}
